module.exports = __webpack_public_path__ + "static/media/about_med.3b15e7b1.jpg";